import React, { useEffect, useState, useContext } from "react";
import AvatarUser from "./components/AvatarUser";
import AvatarSelect from "./components/AvatarSelect";
import AvatarDefault from "../../assets/images/avatar/avatar-empty.svg";
import { BUCKET_SHOP_IMAGES } from "constants/api";
import SystemContext from "context/SystemContext";

const AvatarManager = ({ onCloseMenu }) => {
  // Controla a abertura do modal de seleção de avatar
  const [open, setOpen] = useState(false);

  // Armazena o avatar atualmente exibido na UI
  const [avatar, setAvatar] = useState(AvatarDefault);

  // Dados globais do sistema (usuário logado e lista de avatares)
  const { currentAvatar, setCurrentAvatar, currentUser } =
    useContext(SystemContext);

  // Sincroniza o avatar do usuário logado com o estado local
  // Sempre que o usuário ou a lista global de avatares mudar
  useEffect(() => {
    if (currentUser && currentAvatar) {
      const findUser = currentAvatar.find((item) => {
        return item.sub === currentUser.sub;
      });
      // Se encontrar o usuário, define o avatar salvo
      // Caso não tenha avatar, usa o padrão
      if (findUser) {
        setAvatar(findUser.avatar !== null ? findUser.avatar : AvatarDefault);
      }
    }
  }, [currentUser, currentAvatar]);

  // Verifica se o valor do avatar é um slug, e não uma URL completa
  const isSlug = (image) => {
    return typeof image === "string" && !image.includes("/");
  };

  return (
    <>
      <AvatarUser
        img={isSlug(avatar) ? BUCKET_SHOP_IMAGES(avatar) : AvatarDefault}
        onClick={() => setOpen(true)}
      />

      {/* Modal de seleção de avatar */}
      <AvatarSelect
        open={open}
        selectedAvatar={avatar}
        onClose={() => setOpen(false)}
        onCloseMenu={onCloseMenu}
        onSelect={(newAvatar) => {
          // Atualiza o avatar selecionado na UI
          setAvatar(newAvatar);
        }}
      />
    </>
  );
};

export default AvatarManager;
